import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { NgModelDebounceChangeDirective } from './directives/ngmodel-debounce.directive';
import { AllownumbersonlyDirective } from './directives/numberOnly.directive';
import { PositiveNumberDirective } from './directives/positive-number-input.directive';
import { DocumentAcceptanceComponent } from './document-acceptance/document-acceptance.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { KppErrorMessageComponent } from './error-message/kpp-error-message.component';
import { FormElementsWrapperComponent } from './form-elements-wrapper.component';
import { FormElementsComponent } from './form-elements.component';
import { FormDataResolver } from './form-elements.resolver';
import { formElementsRouting } from './form-elements.routing';
import { FormHeadingComponent } from './form-heading/form-heading.component';
import { FormStepperComponent } from './form-stepper/form-stepper.component';
import { FormService } from './form.service';
import { BaseControlValueAccessorComponent } from './inputs/base-control-value-accessor/base-control-value-accessor.component';
import { CustomDatePickerComponent } from './inputs/custom-date-picker/custom-date-picker.component';
import { FileUploaderComponent } from './inputs/file-uploader/file-uploader.component';
import { FormSelectComponent } from './inputs/form-select/form-select.component';
import { FormTableComponent } from './inputs/form-table/form-table.component';
import { ListingComponent } from './inputs/listing/listing.component';
import { QuantityComponent } from './inputs/quantity/quantity.component';
import { RadioSelectComponent } from './inputs/radio-select/radio-select.component';
import { ScaleComponent } from './inputs/scale/scale.component';
import { TextInputComponent } from './inputs/text-input/text-input.component';
import { TextareaInputComponent } from './inputs/textarea-input/textarea-input.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { TitleComponent } from './title/title.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    FormHeadingComponent,
    FormElementsComponent,
    TextInputComponent,
    TextareaInputComponent,
    BaseControlValueAccessorComponent,
    FileUploaderComponent,
    CustomDatePickerComponent,
    ErrorMessageComponent,
    KppErrorMessageComponent,
    PhoneInputComponent,
    FormSelectComponent,
    RadioSelectComponent,
    ScaleComponent,
    TitleComponent,
    CheckboxGroupComponent,
    DocumentAcceptanceComponent,
    ListingComponent,
    NgModelDebounceChangeDirective,
    AllownumbersonlyDirective,
    FormTableComponent,
    FormStepperComponent,
    QuantityComponent,
    PositiveNumberDirective,
    FormElementsWrapperComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaterialTimepickerModule,
    RouterModule.forChild(formElementsRouting),
    NzIconModule,
    TextFieldModule,
    TranslateModule
  ],
  exports: [ErrorMessageComponent, KppErrorMessageComponent],
  providers: [FormService, FormDataResolver],
})
export class FormElementsModule {}
